import React, { memo } from "react";
import { StarIcon } from "../RFIcon";
import { nanoid } from "nanoid";
interface RarityStarsProps {
	starRank: number;
}

function RarityStars({ starRank }: RarityStarsProps) {
	const starElements = [];
	for (let i = 0; i < starRank; i++) {
		starElements.push(<StarIcon key={nanoid()} className="w-3 h-3 dark:text-white text-primary" />);
	}

	return <>{starElements}</>;
}

// @ts-ignore
function arePropsEqual(prevProps, nextProps) {
	return prevProps.starRank === nextProps.starRank;
}

export default memo(RarityStars, arePropsEqual);
